<template>
  <div id="page">
    <Header />
    <main class="main">
      <div class="fullscreen-wrapper">
        <div class="fullscreen-container">
          <section class="section-main a-center">
            <div class="container a-center">
              <div class="image-bresult">
                <img
                  :src="
                    conf.THEME_PATH + '/assets/page/home/img/vector-complete.png'
                  "
                  alt=""
                />
              </div>
              <div v-if="!saleCode.enable && !email.isEmail">
                <div class="section-heading section-result">
                  <h1 class="heading-h1 c-white">ทำแบบสำรวจครบทุกข้อแล้ว</h1>
                </div>
                <p class="desc detail-desc">
                  ระบบจะประเมินผลสุขภาพทางการเงิน
                  <span class="br">และสุขภาพของคุณเพื่อสรุปเป็นรายงาน</span>
                  พร้อมมอบคำแนะนำที่คุณสามารถนำไปปรับใช้ได้
                </p>
                <div v-if="!email.isEmail">
                  <div class="sc-bstart" v-if="shareButton">
                    <div style="margin-bottom: 10px">
                      <a
                        :href="conf.ResultPath + '?token=' + token"
                        class="btn btn-start"
                        >ดูผลของคุณ</a
                      >
                    </div>
                    <div style="margin-bottom: 10px">
                      <button class="btn btn-start" @click="sendEmail()">
                        แชร์ข้อมูล
                      </button>
                    </div>
                    <div style="margin-bottom: 10px">
                      <button class="btn btn-start" @click="reset()">
                        เริ่มใหม่อีกครั้ง
                      </button>
                    </div>
                  </div>
                  <div class="sc-bstart" v-else>
                    <div style="margin-bottom: 10px">
                      <a
                        :href="conf.ResultPath + '?token=' + token"
                        class="btn btn-start"
                        >ดูผลของคุณ</a
                      >
                    </div>
                    <div style="margin-bottom: 10px">
                      <button class="btn btn-start" @click="reset()">
                        เริ่มใหม่อีกครั้ง
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Sale Code -->
              <div v-else-if="saleCode.enable">
                <div
                  class="icw-fieldset-inner"
                  style="background: transparent; box-shadow: none"
                >
                  <ul class="icw-fields">
                    <li class="icw-field icw-field-full">
                      <div class="icw-input">
                        <label for="" class="icw-label overlabel"
                          >รหัสประจำตัวฝ่ายขาย<span class="c-star"
                            ><sup>*</sup></span
                          ></label
                        >
                        <input
                          type="text"
                          v-model="saleCode.data"
                          :class="{ 'input-required': !isSaleCode }"
                          maxlength="8"
                          pattern="\d*"
                          @keyup="validSaleCode()"
                        />
                        <p class="input-note c-white" v-if="!isSaleCode">
                          กรุณาระบุรหัสประจำตัวฝ่ายขายใหม่อีกครั้ง<span
                            class="c-star"
                            ><sup>*</sup></span
                          >
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                <button
                  type="button"
                  class="btn btn-start"
                  :class="{ 'btn-disabled': !isPass }"
                  @click="beforeSaveData()"
                >
                  ส่งแบบประเมิน
                </button>
              </div>

              <!-- Email -->
              <div v-else-if="email.isEmail">
                <div
                  class="icw-fieldset-inner"
                  style="background: transparent; box-shadow: none"
                >
                  <ul class="icw-fields">
                    <li class="icw-field icw-field-full">
                      <div class="icw-input">
                        <label for="" class="icw-label overlabel"
                          >อีเมล<span class="c-star"><sup>*</sup></span></label
                        >
                        <input
                          type="email"
                          v-model="email.data"
                          :class="{ 'input-required': !email.isEmailValid }"
                          maxlength="100"
                          @blur="validEmailAlert()"
                        />
                        <p
                          class="input-note c-white"
                          v-if="!email.isEmailValid"
                        >
                          รูปแบบอีเมลไม่ถูกต้อง<span class="c-star"
                            ><sup>*</sup></span
                          >
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="icw-fieldset-action previous">
                  <button
                    type="button"
                    class="btn btn-previous previous"
                    @click="cancelEmail()"
                  >
                    ยกเลิก
                  </button>
                </div>
                <button
                  type="button"
                  class="btn btn-next next btn-send"
                  :class="{ 'btn-disabled': !email.isEmailValid }"
                  @click="sendEmail()"
                >
                  ส่งอีเมล
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import jQuery from "jquery";

import MyConfig from "@/../me.config.js";

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { fileURLToPath } from "url";

import axios from "axios";
import VueAxios from "vue-axios";

import { is_email } from "@/helpers/validate_helper.js";
import { log } from "util";
window.jQuery = window.$ = jQuery;

Vue.use(VueAxios, axios);

export default {
  name: "Result",
  components: {
    Header,
    Footer,
  },
  mounted() {
    this.$nextTick(() => {
      let status = sessionStorage.getItem("salecode_button");

      let a = JSON.parse(sessionStorage.getItem("question_result"));
      this.token = a.token;
      this.saleCode.enable = false;

      let share = sessionStorage.getItem("share_button");
      if (share == 1) {
        this.shareButton = true;
      }

      let contact = JSON.parse(sessionStorage.getItem("Contact"));
      if (contact != null) {
        this.email.data = contact.email;
      }
    });
    // if (a == '' || a == null) window.location.href = MyConfig.InfoPath
  },
  data() {
    return {
      saleCode: {
        data: "",
        enable: false,
      },
      isSaleCode: true,
      isSaleCodeValid: false,
      callApi: true,
      shareButton: false,
      accessToken: "",
      email: {
        data: "",
        isEmail: false,
        isEmailValid: true,
      },
      conf: MyConfig,
      enableButton:
        typeof _ENABLE_BUTTON !== "undefined" ? parseInt(_ENABLE_BUTTON) : 0,
      token: "",
    };
  },
  watch: {
    email: function(n, o) {
      Vue.nextTick(() => {
        this.email.data = n.replace(/[^a-zA-Z0-9\@\.\_\-]/g, "");
      });
    },
  },
  methods: {
    validEmailAlert() {
      this.isEmailValid = true;
      let pass = true;
      if (this.email.data != "" && !is_email(this.email.data)) {
        pass = false;
      }
      if (!pass) this.email.isEmailValid = false;
      console.log(!is_email(this.email.data));

      console.log(this.email.isEmailValid);

      return pass;
    },
    validSaleCode() {
      let pass = true;
      this.isSaleCodeValid = true;
      if (this.saleCode.data == "") {
        pass = false;
      } else if (this.saleCode.data != "" && this.saleCode.data.length < 8) {
        pass = false;
      }
      if (!pass) (this.isSaleCode = true), (this.isSaleCodeValid = false);
      return pass;
    },
    beforeSaveData() {
      if (this.isSaleCode) {
        const date = new Date();
        let req = `saleCode=${this.saleCode.data}&sendDateTime=${date}`;

        let header = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        };
        let self = this;

        // Require Sale Code
        this.axios
          .post(MyConfig.REST_PATH.getSaleInfo, req, header)
          .then((res) => {
            if (
              res.status == 200 &&
              res.data.responseRecord.saleInformationList != null
            ) {
              self.saveData();
            } else {
              self.isSaleCode = false;
              self.isSaleCodeValid = false;
            }
          })
          .catch((err) => {
            self.saveData();
          });
      }
    },
    saveData() {
      let _goodwealthandhealth = localStorage.getItem("goodwealthandhealth");
      let _information = JSON.parse(sessionStorage.getItem("Information"));
      let _job = JSON.parse(sessionStorage.getItem("Job"));
      let _contact = JSON.parse(sessionStorage.getItem("Contact"));
      let _profile = JSON.parse(sessionStorage.getItem("Profile"));
      let _income = JSON.parse(sessionStorage.getItem("Income"));
      let _lifestyle = JSON.parse(sessionStorage.getItem("LifeStyle"));
      let _healthy = JSON.parse(sessionStorage.getItem("Healthy"));
      let _lifestyle_gadget = JSON.parse(
        sessionStorage.getItem("LifestyleGadget")
      );
      let _healthy_activities = JSON.parse(
        sessionStorage.getItem("HealthyActivities")
      );
      let _run_activities = JSON.parse(sessionStorage.getItem("RunActivities"));
      let _bike_activities = JSON.parse(
        sessionStorage.getItem("BikeActivities")
      );

      let _child_parent = JSON.parse(sessionStorage.getItem("ChildParent"));
      let _expenses = JSON.parse(sessionStorage.getItem("Expenses"));
      let _money_health_1 = JSON.parse(sessionStorage.getItem("MoneyHealth1"));
      let _money_health_2 = JSON.parse(sessionStorage.getItem("MoneyHealth2"));
      let _money_health_3 = JSON.parse(sessionStorage.getItem("MoneyHealth3"));
      let _money_health_4 = JSON.parse(sessionStorage.getItem("MoneyHealth4"));
      let _money_health_5 = JSON.parse(sessionStorage.getItem("MoneyHealth5"));
      let _money_health_6 = JSON.parse(sessionStorage.getItem("MoneyHealth6"));
      let _money_health_7 = JSON.parse(sessionStorage.getItem("MoneyHealth7"));
      let _money_health_8 = JSON.parse(sessionStorage.getItem("MoneyHealth8"));

      let _health_info = JSON.parse(sessionStorage.getItem("HealthInfo"));
      let _workout_rate = JSON.parse(sessionStorage.getItem("WorkoutRate"));
      let _workout_time = JSON.parse(sessionStorage.getItem("WorkoutTime"));
      let _relax_time = JSON.parse(sessionStorage.getItem("RelaxTime"));
      let _wakeup_freq = JSON.parse(sessionStorage.getItem("WakeupFreq"));
      let _ride_freq = JSON.parse(sessionStorage.getItem("RideFreq"));
      let _hangout_freq = JSON.parse(sessionStorage.getItem("HangoutFreq"));
      let _use_mobile_phone = JSON.parse(
        sessionStorage.getItem("UseMobilePhone")
      );
      let _cigarette = JSON.parse(sessionStorage.getItem("Cigarrete"));
      let _cancer = JSON.parse(sessionStorage.getItem("Cancer"));
      let _eat_hotdog = JSON.parse(sessionStorage.getItem("EatHotdog"));
      let _milk_tea = JSON.parse(sessionStorage.getItem("MilkTea"));
      let _fried = JSON.parse(sessionStorage.getItem("Fried"));
      let _noodle = JSON.parse(sessionStorage.getItem("Noodle"));
      let _bored = JSON.parse(sessionStorage.getItem("Bored"));
      let _dismal = JSON.parse(sessionStorage.getItem("Dismal"));
      let _not_focus = JSON.parse(sessionStorage.getItem("NotFocus"));
      let _resolve = JSON.parse(sessionStorage.getItem("Resolve"));

      let _sale_code = this.saleCode.data;

      let self = this;

      let api_url = MyConfig.API_PATH;

      this.axios
        .post(
          api_url + "/api/save_data/" + localStorage.getItem("uuid"),
          $.param({
            _campaign:
              typeof window._site_params !== "undefined"
                ? window._site_params.campaign
                : "",
            _information: _information,
            _job: _job,
            _contact: _contact,
            _profile: _profile,
            _income: _income,
            _lifestyle: _lifestyle,
            _healthy: _healthy,
            _lifestyle_gadget: _lifestyle_gadget,
            _healthy_activities: _healthy_activities,
            _run_activities: _run_activities,
            _bike_activities: _bike_activities,

            _child_parent: _child_parent,
            _expenses: _expenses,
            _money_health_1: _money_health_1,
            _money_health_2: _money_health_2,
            _money_health_3: _money_health_3,
            _money_health_4: _money_health_4,
            _money_health_5: _money_health_5,
            _money_health_6: _money_health_6,
            _money_health_7: _money_health_7,
            _money_health_8: _money_health_8,

            _health_info: _health_info,
            _workout_rate: _workout_rate,
            _workout_time: _workout_time,
            _relax_time: _relax_time,
            _wakeup_freq: _wakeup_freq,
            _ride_freq: _ride_freq,
            _hangout_freq: _hangout_freq,
            _use_mobile_phone: _use_mobile_phone,
            _cigarette: _cigarette,
            _cancer: _cancer,
            _eat_hotdog: _eat_hotdog,
            _milk_tea: _milk_tea,
            _fried: _fried,
            _noodle: _noodle,
            _bored: _bored,
            _dismal: _dismal,
            _not_focus: _not_focus,
            _resolve: _resolve,

            _sale_code: _sale_code,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((resp) => {
          if (resp.data.response == "success") {
            sessionStorage.setItem(
              "question_result",
              JSON.stringify({
                code: resp.data.code,
                firstname: _information.firstname,
                lastname: _information.lastname,
                token: resp.data.token,
              })
            );
            self.token = resp.data.token;

            sessionStorage.removeItem("Information");
            sessionStorage.removeItem("Job");
            // sessionStorage.removeItem('Contact')
            sessionStorage.removeItem("Profile");
            sessionStorage.removeItem("Income");
            sessionStorage.removeItem("LifeStyle");
            sessionStorage.removeItem("Healthy");
            sessionStorage.removeItem("LifestyleGadget");
            sessionStorage.removeItem("HealthyActivities");
            sessionStorage.removeItem("RunActivities");
            sessionStorage.removeItem("BikeActivities");

            sessionStorage.removeItem("ChildParent");
            sessionStorage.removeItem("Expenses");
            sessionStorage.removeItem("MoneyHealth1");
            sessionStorage.removeItem("MoneyHealth2");
            sessionStorage.removeItem("MoneyHealth3");
            sessionStorage.removeItem("MoneyHealth4");
            sessionStorage.removeItem("MoneyHealth5");
            sessionStorage.removeItem("MoneyHealth6");
            sessionStorage.removeItem("MoneyHealth7");
            sessionStorage.removeItem("MoneyHealth8");

            sessionStorage.removeItem("HealthInfo");
            sessionStorage.removeItem("WorkoutRate");
            sessionStorage.removeItem("WorkoutTime");
            sessionStorage.removeItem("RelaxTime");
            sessionStorage.removeItem("WakeupFreq");
            sessionStorage.removeItem("RideFreq");
            sessionStorage.removeItem("HangoutFreq");
            sessionStorage.removeItem("UseMobilePhone");
            sessionStorage.removeItem("Cigarrete");
            sessionStorage.removeItem("Cancer");
            sessionStorage.removeItem("EatHotdog");
            sessionStorage.removeItem("MilkTea");
            sessionStorage.removeItem("Fried");
            sessionStorage.removeItem("Noodle");
            sessionStorage.removeItem("Bored");
            sessionStorage.removeItem("Dismal");
            sessionStorage.removeItem("NotFocus");
            sessionStorage.removeItem("Resolve");

            sessionStorage.removeItem("step1");
            sessionStorage.removeItem("step2");
            sessionStorage.removeItem("step3");
            sessionStorage.removeItem("skipQuize10");

            self.saleCode.enable = false;
            sessionStorage.removeItem("userEmail");
            sessionStorage.removeItem("salecode_button");
          } else {
            alert("กรุณาลองใหม่อีกครั้ง หรือติดต่อผู้ดูแลระบบ");
          }
        })
        .catch((err) => {
          console.log("catch : ", err);
          alert("กรุณาลองใหม่อีกครั้ง หรือติดต่อผู้ดูแลระบบ");
        });
    },
    cancelEmail() {
      this.email.isEmail = false;
    },
    sendEmail() {
      if (!this.email.isEmail) {
        this.email.isEmail = true;
      } else {
        let api_url = MyConfig.API_PATH;

        let self = this;

        let param = {
          email: this.email.data,
          url: this.conf.ResultPath + "?token=" + this.token,
          campaign:
            typeof window._site_params !== "undefined"
              ? window._site_params.campaign
              : "",
        };

        this.axios
          .post(api_url + "/api/send_email", $.param(param), {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          })
          .then((resp) => {
            if (resp.data.response == "success") {
              sessionStorage.removeItem("Contact");
              self.email.isEmail = false;
            } else {
              alert("กรุณาลองใหม่อีกครั้ง หรือติดต่อผู้ดูแลระบบ");
            }
          })
          .catch((err) => {
            console.log("catch : ", err);
            alert("กรุณาลองใหม่อีกครั้ง หรือติดต่อผู้ดูแลระบบ");
          });
      }
    },
    reset() {
      localStorage.removeItem("uuid");
      localStorage.removeItem("tl_accept_consent");
      window.location.href = MyConfig.HomePath;
    },
  },
  computed: {
    isPass() {
      // this.isSaleCode = true
      return this.isSaleCodeValid;
    },
  },
};
</script>
